import { createSlice } from '@reduxjs/toolkit'

const initialState = [
    {id: '',
    username: '',
    userImage: '',
    gametype: '',
    team1: '',
    team2: '',
    logot1: '',
    logot2: '',
    peshT1: '',
    peshT2: '',
    result: ''}
]

const peshbinisSlice = createSlice({
    name: "peshbinis",
    initialState,
    reducers: {
        peshbinis: (state, action) => {
            state.id=
            state.username = action.payload.userName;
            state.userImage = action.payload.userImage;
            state.gametype = action.payload.gametype;
            state.team1 = action.payload.team1;
            state.team2 = action.payload.team2;
            state.logot1 = action.payload.logot1;
            state.logot2 = action.payload.logot2;
            state.peshT1 = action.payload.peshT1;
            state.peshT2 = action.payload.peshT2;
            state.result = action.payload.result;

            localStorage.setItem('peshbinis', JSON.stringify(action.payload));
        },
    }
});

export const {peshbinis } = peshbinisSlice.actions

export default peshbinisSlice.reducer